import React from 'react';
import { Search } from 'lucide-react';

interface DeepResearchToggleProps {
  isEnabled: boolean;
  onToggle: (enabled: boolean) => void;
  className?: string;
}

const DeepResearchToggle: React.FC<DeepResearchToggleProps> = ({
  isEnabled,
  onToggle,
  className = ''
}) => {
  return (
    <div className={`flex items-center gap-2 ${className}`}>
      <div className="flex items-center gap-2">
        <span className="text-xs text-[var(--rhea-text-secondary)]">Deep</span>
        <button
          onClick={() => onToggle(!isEnabled)}
          className={`relative inline-flex h-5 w-9 items-center rounded-full transition-colors duration-200 ${
            isEnabled 
              ? 'bg-[var(--rhea-accent-primary)]' 
              : 'bg-[var(--rhea-card-border)]'
          }`}
          title={isEnabled ? "Deep Research enabled" : "Deep Research disabled"}
        >
          <span
            className={`inline-block h-3 w-3 transform rounded-full bg-white transition-transform duration-200 ${
              isEnabled ? 'translate-x-5' : 'translate-x-1'
            }`}
          />
        </button>
      </div>
    </div>
  );
};

export default DeepResearchToggle; 